import { authHeader, handleResponse } from 'helpers';
import { config } from './Config';

export const dayOffService = {
  fetchDayOff,
  deleteDayOff,
  updateDayOff,
  createDayOff,
};

function fetchDayOff(filter, offset, limit) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader(),
    mode: 'cors',
  };
  const urlFilter = JSON.stringify(filter);
  return fetch(
    `${config.apiUrl}/api/dayoff?filter=${urlFilter}&offset=${offset}&limit=${limit}`,
    requestOptions
  ).then(handleResponse);
}

function deleteDayOff(dayOffId) {
  const headers = authHeader();
  const requestOptions = {
    method: 'DELETE',
    headers,
    mode: 'cors',
  };

  return fetch(`${config.apiUrl}/api/dayoff/delete/${dayOffId}`, requestOptions).then(
    handleResponse
  );
}

function updateDayOff(id, data) {
  const body = JSON.stringify({
    id,
    date: data.dayOff,
  });

  const headers = {
    'Content-Type': 'application/json',
    ...authHeader(false),
  };
  const requestOptions = {
    method: 'PUT',
    headers,
    body,
    mode: 'cors',
  };
  return fetch(`${config.apiUrl}/api/dayoff/update`, requestOptions).then(handleResponse);
}

function createDayOff(platformId, day) {
  const body = JSON.stringify({
    date: day,
    platform: { id: platformId },
  });

  const headers = {
    'Content-Type': 'application/json',
    ...authHeader(false),
  };
  const requestOptions = {
    method: 'POST',
    headers,
    body,
    mode: 'cors',
  };
  return fetch(`${config.apiUrl}/api/dayoff/add`, requestOptions).then(handleResponse);
}
